<template>
    <div class="flex items-center">
        <div class="flex flex-1 justify-start items-center">
            <div class="flex items-center justify-center">
                <label class="flex items-center cursor-pointer">
                    <div class="relative">
                        <input 
                            type="checkbox" 
                            :checked="modelValue" 
                            class="sr-only" 
                            @input="$emit('update:modelValue', $event.target.checked)"
                        />

                        <div 
                            class="block w-[40px] h-[24px] rounded-full"
                            :class="{'bg-[#108FE5]': modelValue, 'bg-[#CFD6EA]': !modelValue}"
                        />

                        <div 
                            class="absolute left-[3px] top-[3px] bg-white w-[18px] h-[18px] rounded-full transition"
                            :class="{'transform translate-x-[90%]': modelValue}"
                        />

                    </div>
                </label>
            </div>

            <p 
                class="text-[14px] ml-2 leading-snug text-[#1B2F51]" 
                :class="{'font-semibold': modelValue}"
            >
                {{ name }}
            </p>

            <v-tooltip location="right">
                <template v-slot:activator="{ props }">
                    <img
                        v-bind="props"
                        src="/images/campaigns/tooltip-icon.svg"
                        class="cursor-pointer ml-2 -mt-[1.5px]"
                        alt="Tooltip icon"
                    />
                </template>

                <span>{{ tooltipContent }}</span>
            </v-tooltip>
        </div>

        <p 
            class="text-[14px] ml-4 leading-loose text-[#141430]"
            :class="{'font-bold': modelValue}">
            +{{ $numberHelper.formatMoneyObject(priceValue, true) }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
        tooltipContent: {
            type: String,
            required: true,
        },
        priceValue: {
            type: Number,
            required: true,
        },
    },
};
</script>
